import { atom } from "recoil";

export const clientEditModalStore = atom({
	key: "clientEditModalStore",
	default: {
		show: false,
		loaded: true,
		id: 0,
		values: {
			enabledProviders: null
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
